const calculateStickyPartOffset = () => {
  const headings = document.querySelector('.product-tabs-headings');
  if (!headings) return 0;
  let stickyPartOffset = headings.offsetHeight;
  if (window.matchMedia('(max-width: 767px)').matches) {
    const hdr = document.querySelector('.swahdr');
    if (hdr) stickyPartOffset += hdr.offsetHeight;
  } else {
    const nav = document.querySelector('.swanavsec');
    if (nav) stickyPartOffset += nav.offsetHeight;
  }
  return stickyPartOffset;
};

let isScrollingByClick = false;
const scrollToProductTabSection = $this => {

  const tabTitle = $this.dataset.tabTitle;

   let stickyPartOffset = calculateStickyPartOffset();

      // Temporarily disable the scroll event handling
        isScrollingByClick = true;
  
   let newStickyPartOffset = stickyPartOffset + 10;
  if(!$(".product-tabs-headings-wrapper.sticky").length) {
    newStickyPartOffset += $(".product-tabs-heading-wrapper:first").height();
  }

  document.querySelectorAll(`.product-tabs-heading-wrapper`).forEach(productTabsHeading => productTabsHeading.classList.remove("active-tab"));
$this.classList.add("active-tab");

  setTimeout(function(){

    // Bring the clicked tab into view inside the horizontal tabs bar (no page scroll).
    var clickedTabEl = document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${tabTitle}"]`);
    var tabsBar = document.querySelector('.product-tabs-headings');
    if (clickedTabEl && tabsBar) {
      var barRect = tabsBar.getBoundingClientRect();
      var tabRect = clickedTabEl.getBoundingClientRect();
      var tabVisualLeft  = tabRect.left  - barRect.left;
      var tabVisualRight = tabRect.right - barRect.left;
      if (tabVisualLeft < 0 || tabVisualRight > barRect.width) {
        var savedScrollX = window.scrollX;
        if (tabVisualLeft < 0) {
          tabsBar.scrollLeft += tabVisualLeft;
        } else {
          tabsBar.scrollLeft += tabVisualRight - barRect.width;
        }
        if (window.scrollX !== savedScrollX) {
          window.scrollTo({ left: savedScrollX, top: window.scrollY, behavior: 'instant' });
        }
      }
    }
    
  }, 550);

  
    $('html').animate({
    scrollTop: $(`.product-tab-section[data-tab-section="${tabTitle}"]`).offset().top - newStickyPartOffset
    }, 500);

      // Re-enable scroll handling after the scrolling ends
        setTimeout(() => {
            isScrollingByClick = false;
        }, 1000); // 1000ms (1 second) should be enough time to complete the scroll
};
const $productTabHeadings = $(".product-tabs-headings");

    function initLovapetsProductRecsSlick() {
      var $slider = $('.seo-optimized-template .product-recommendations-wrapper .collection-products > div').first();
      if (!$slider.length) return;

      var $cards = $slider.children('article, .item');
      if ($cards.length < 1) return;

      if ($slider.hasClass('slick-initialized')) {
        try {
          $slider.slick('unslick');
        } catch (e) {}
      }

      $slider.slick({
        slidesToShow: 3,
        dots: false,
        arrows: true,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              infinite: true,
              slidesToShow: 1,
              dots: true,
              arrows: false,
              slidesToScroll: 1
            }
          }
        ]
      });

      function refreshSlick() {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('setPosition');
        }
      }

      function fullRecalc() {
        if ($slider.hasClass('slick-initialized')) {
          $(window).trigger('resize');
        }
      }

      $slider.find('img').off('load.lpRecs').on('load.lpRecs', refreshSlick);
      $(window).off('load.lpRecs').on('load.lpRecs', refreshSlick);

      // Cached images never fire 'load' — call refreshSlick for any already complete
      $slider.find('img').each(function () {
        if (this.complete) refreshSlick();
      });

      setTimeout(refreshSlick, 0);
      setTimeout(refreshSlick, 200);
      setTimeout(refreshSlick, 800);
      setTimeout(refreshSlick, 2200);

      // Trigger a real window resize so Slick fully recalculates slide widths/heights.
      // setPosition alone doesn't fix width miscalculation from AJAX/deferred init.
      setTimeout(fullRecalc, 150);
      setTimeout(fullRecalc, 600);
    }

    window.initLovapetsProductRecsSlick = initLovapetsProductRecsSlick;

    $(function () {
      if (!document.querySelector('.seo-optimized-template .product-recommendations-wrapper')) return;
      [200, 900, 2000].forEach(function (ms) {
        setTimeout(initLovapetsProductRecsSlick, ms);
      });
    });

    // Mobile only: when the "i" info tooltip in the recommendations slider is
    // tapped, add .lp-tooltip-open to its .slick-list so overflow:visible +
    // clip-path activates and the upward tooltip is fully visible.
    // On close (X button or tap outside) the class is removed.
    (function () {
      var RECS = '.seo-optimized-template .product-recommendations-wrapper';

      function recsSlickList(el) {
        var sl = el.closest('.slick-list');
        // Only target slick-lists inside the recommendations wrapper
        return sl && sl.closest(RECS) ? sl : null;
      }

      function openMobileTooltip(sl) {
        if (sl) sl.classList.add('lp-tooltip-open');
      }

      function closeMobileTooltip() {
        var savedY = window.scrollY;
        var savedX = window.scrollX;
        document.querySelectorAll(RECS + ' .slick-list.lp-tooltip-open')
          .forEach(function (sl) { sl.classList.remove('lp-tooltip-open'); });
        // Overflow switching back to hidden can trigger a scroll reflow —
        // restore position instantly so the page doesn't jump.
        window.scrollTo({ top: savedY, left: savedX, behavior: 'instant' });
      }

      document.addEventListener('click', function (e) {
        if (!window.matchMedia('(max-width: 767px)').matches) return;

        // Tapped the "i" icon (info tooltip)
        var icon = e.target.closest(
          RECS + ' .product-info-tooltip-wrapper:not(.product-qty-info-tool-tip) .product-info-tooltip-icon'
        );
        if (icon) {
          openMobileTooltip(recsSlickList(icon));
          return;
        }

        // Tapped the "30ml" badge icon
        var qtyIcon = e.target.closest(
          RECS + ' .product-info-tooltip-wrapper.product-qty-info-tool-tip .product-info-tooltip-icon'
        );
        if (qtyIcon) {
          openMobileTooltip(recsSlickList(qtyIcon));
          return;
        }

        // Tapped the close "X" inside either tooltip
        var closeBtn = e.target.closest(RECS + ' .product-info-tooltip-wrapper .tooltip-close-icon');
        if (closeBtn) {
          closeMobileTooltip();
          return;
        }

        // Tapped anywhere outside any tooltip wrapper → close
        if (!e.target.closest(RECS + ' .product-info-tooltip-wrapper')) {
          closeMobileTooltip();
        }
      });
    }());

    
  document.addEventListener("DOMContentLoaded", (event) => {   
  const options = {
  threshold:0.25
  }

const productTabSections = document.querySelectorAll(".product-tab-sections-wrapper .product-tab-section");
if (!productTabSections.length) {
  return;
}

// Track the last active section so we only update the tab bar when it actually changes.
let _lastActiveSection = null;

const navHighlighter = () => {

   if (isScrollingByClick) return; // Do nothing if scrolling by click

  var $tabSectionsEl = $('.product-tabs-sections');
  if (!$tabSectionsEl.length || !$tabSectionsEl.offset()) return;
  
  // Get current scroll position
  let scrollY = window.pageYOffset;
  let stickyPartOffset = calculateStickyPartOffset() + 70;


  var productTabs = $('.product-tabs-headings-wrapper.sticky-tab-headings');
var heightThreshold = $tabSectionsEl.offset().top;

let stickyPartOffset1 = calculateStickyPartOffset();

heightThreshold -= stickyPartOffset1;

  heightThreshold += 30;
  
  if(scrollY < heightThreshold) {
    return;
  }

  let activeSection;
  
  // Now we loop through sections to get height, top and ID values for each
  productTabSections.forEach(productTabSection => {
    let sectionHeight = productTabSection.offsetHeight;
    let sectionTop = productTabSection.offsetTop - stickyPartOffset;

   if(document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${productTabSection.dataset.tabSection}"]`)){

      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight){
      
      activeSection = productTabSection.dataset.tabSection;
      } 

      }

  });

  // Only act when the active section actually changes — prevents repeated
  // DOM writes (and horizontal tab-bar scroll) on every scroll event.
  if (!activeSection || activeSection === _lastActiveSection) return;
  _lastActiveSection = activeSection;

    if(document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${activeSection}"]`)){

    // Update active tab highlight
    document.querySelectorAll(`.product-tabs-heading-wrapper`).forEach(productTabsHeading => productTabsHeading.classList.remove("active-tab"));
    var activeTabEl = document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${activeSection}"]`);
    activeTabEl.classList.add("active-tab");

    // Bring the active tab into view inside the horizontal tabs bar.
    // Uses getBoundingClientRect so position is accurate even when the bar is position:fixed.
    // Saves/restores window.scrollX to guard against mobile browsers (iOS Safari) that
    // can shift the page horizontally as a side-effect of programmatic scrollLeft changes.
    var tabsBar = document.querySelector('.product-tabs-headings');
    if (tabsBar) {
      var barRect = tabsBar.getBoundingClientRect();
      var tabRect = activeTabEl.getBoundingClientRect();
      var tabVisualLeft  = tabRect.left  - barRect.left;
      var tabVisualRight = tabRect.right - barRect.left;
      if (tabVisualLeft < 0 || tabVisualRight > barRect.width) {
        var savedScrollX = window.scrollX;
        if (tabVisualLeft < 0) {
          tabsBar.scrollLeft += tabVisualLeft;
        } else {
          tabsBar.scrollLeft += tabVisualRight - barRect.width;
        }
        if (window.scrollX !== savedScrollX) {
          window.scrollTo({ left: savedScrollX, top: window.scrollY, behavior: 'instant' });
        }
      }
    }

    }
  
}

const scrollProductTab = $direction => {

  let scrollableWrapper = document.querySelector(".product-tabs-headings");
  if (!scrollableWrapper) return;
  scrollableWrapper.style.scrollBehaviour = "smooth";
  let scrollAmount = 110;
  if($direction == "right"){

    scrollableWrapper.scrollLeft += scrollAmount;
  } else {
    scrollableWrapper.scrollLeft -= scrollAmount
  }
}
window.scrollProductTab = scrollProductTab;

  let navHighlighterRaf = null;
  function scheduleNavHighlighter() {
    if (navHighlighterRaf != null) return;
    navHighlighterRaf = requestAnimationFrame(function () {
      navHighlighterRaf = null;
      navHighlighter();
    });
  }
  window.addEventListener('scroll', scheduleNavHighlighter, { passive: true });

  }); 

const showReviews = () => {

     setTimeout(function(){
        $('html').animate({
    scrollTop: $(document.querySelector('[data-tab-section*="description-parts-avis-"]')).offset().top - 100
    }, 250);
   }, 500)

}
const showMoreContent = $this => {

  const currentScrollPosition = window.scrollY;
  let isCollasped = $this.closest(".product-tab-section").classList.contains("collapsed");
  $this.closest(".product-tab-section").classList.toggle("collapsed");

     let stickyPartOffset = calculateStickyPartOffset();

   let newStickyPartOffset = stickyPartOffset + 100;
  if(!$(".product-tabs-headings-wrapper.sticky").length) {
    newStickyPartOffset += $(".product-tabs-heading-wrapper:first").height();
  }

     // Animate scrolling to the end of the section
  if(!isCollasped){
      let $tabSection = $($this.closest(".product-tab-section"));
        $('html').animate({
            scrollTop: ($tabSection.offset().top + $tabSection.outerHeight() - $(window).height())+150
        }, 300);
  } else {

   window.scrollTo(0, currentScrollPosition);
    
  }

}

$(function() {
  var $sections = $('.product-tabs-sections');
  var $productTabs = $('.product-tabs-headings-wrapper.sticky-tab-headings');
  var tabsEl = document.querySelector('.product-tabs-headings-wrapper.sticky-tab-headings');
  if (!$sections.length || !$productTabs.length || !tabsEl) {
    return;
  }

  var stickyPartOffset = calculateStickyPartOffset();
  var heightThreshold = $sections.offset().top - stickyPartOffset;
  var heightThreshold_end = heightThreshold + $sections.height();

  var stickyTabsRaf = null;

  function applyStickyTabBar() {
    var scroll = $(window).scrollTop();
    var topOffset;
    if (window.matchMedia('(max-width: 767px)').matches) {
      var stickyShell = document.querySelector('.lovapets-header-shell') || document.querySelector('#shopify-section-header');
      var swahdr = document.querySelector('.swahdr');
      topOffset = stickyShell ? stickyShell.offsetHeight : (swahdr ? swahdr.offsetHeight : 0);
    } else {
      var navSec = document.querySelector('.swanavsec');
      topOffset = navSec ? navSec.offsetHeight : 0;
    }

    var scrollToCheck = parseInt(heightThreshold, 10);
    scroll = parseInt(scroll, 10);

    if (scroll < scrollToCheck) {
      $productTabs.removeClass('sticky');
      $productTabs.removeAttr('data-lp-sticky-top');
      return;
    }

    if (scroll >= scrollToCheck && scroll <= heightThreshold_end) {
      $productTabs.addClass('sticky');

      if (!tabsEl.classList.contains('scroll-adjusted')) {
        if (!window.matchMedia('(max-width: 767px)').matches) {
          window.scrollTo({
            top: window.scrollY - 10,
            behavior: 'smooth'
          });
        }
        tabsEl.classList.add('scroll-adjusted');
      }

      var topStr = String(topOffset);
      if ($productTabs.attr('data-lp-sticky-top') !== topStr) {
        $productTabs.css({ top: topOffset + 'px' });
        $productTabs.attr('data-lp-sticky-top', topStr);
      }
    } else {
      tabsEl.classList.remove('scroll-adjusted');
      $productTabs.removeClass('sticky');
      $productTabs.removeAttr('data-lp-sticky-top');
    }
  }

  function onStickyTabsScroll() {
    if (stickyTabsRaf != null) return;
    stickyTabsRaf = requestAnimationFrame(function () {
      stickyTabsRaf = null;
      applyStickyTabBar();
    });
  }

  $(window).on('scroll.lpSeoStickyTabs', onStickyTabsScroll);

  var wrapper = document.querySelector('.product-tab-sections-wrapper');
  if (wrapper) {
    var allProductSections = wrapper.querySelectorAll('.product-tab-section');
    allProductSections.forEach(function (allProductSection) {
      var innerContent = allProductSection.querySelector('.station-tabs-content');
      if (innerContent && innerContent.clientHeight >= 700) {
        allProductSection.classList.add('collapsed');
        var vm = allProductSection.querySelector('.view-more-content');
        if (vm) vm.classList.remove('hide');
      }
    });
  }
})